import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import StarRating from "./StarRating";
import { useDispatch, useSelector } from "react-redux";
import { alterCart } from "../../store/cart/CartActions";
import { Whatsapp } from "react-bootstrap-icons";

const ProductContainer = ({ product, showBtn = true, refetchItem = false }) => {
  const [percentOff, setPercentOff] = useState(0);

  const dispatch = useDispatch();

  const { loading, shopping_cart } = useSelector((state) => state.cart);

  useEffect(() => {
    function calculatePercentOff() {
      let perc = 0;
      if (product) {
        if (product.price && product.regular_price) {
          perc =
            ((product.regular_price - product.price) / product.regular_price) *
            100;
        }
      }

      return perc;
    }
    setPercentOff(calculatePercentOff());
  }, [product]);

  return (
    <div
      className="prodContainer"
      itemScope
      itemType="https://schema.org/Product"
    >
      {product?.stock_status === "outofstock" && (
        <div className="product_right_actions">
          <span>Out Of Stock</span>
        </div>
      )}

      <div className="product_left_actions">
        {product?.stock_status !== "instock" ? (
          <></>
        ) : (
          <Link
            to={`https://wa.me/254758281555/?text=${encodeURIComponent(
              "Hello, I would like to purchase \n\nProduct :" +
                `${product.name}` +
                "\nPrice : Ksh " +
                `${product.price}` +
                `\nURL : ${encodeURI(
                  `https://www.tcfstore.com/product/${product.name}-${product.id}`
                )}` +
                "/\n\nThank you."
            )}`}
            target="_blank"
          >
            <Whatsapp size={25} color="green" type="icon" />{" "}
          </Link>
        )}
      </div>
      <Link
        to={`/product/${product?.name}-${product?.id}`}
        state={{ item: refetchItem ? null : product }}
      >
        <img
          src={`${process.env.REACT_APP_API_URL}\\${
            product.images[0]?.src ?? ""
          }`}
          alt={product.images[0]?.alt ?? ""}
          itemProp="image"
        />
        <p className="name" itemProp="name">
          {product.name}
        </p>
      </Link>
      <p
        style={{ display: "none", fontSize: "5px", fontWeight: "normal" }}
        itemprop="description"
      >
        {product.short_description}
      </p>
      <p className="prodPrice">
        <span itemProp="priceCurrency" content="KES">
          Ksh.
        </span>{" "}
        <span itemProp="price" content={product.price}>
          {product.price}
        </span>
      </p>
      {percentOff >= 1 ? (
        <p>
          <span className="prodRegPrice">{product.regular_price}</span>
          <span className="prodPercOff"> -{percentOff.toFixed(1)}% </span>
        </p>
      ) : (
        <></>
      )}
      {product.rating_count >= 1 ? (
        <StarRating key={product.id} value={product.average_rating} />
      ) : (
        <StarRating key={product.id} value={0} />
      )}

      {showBtn ? (
        (shopping_cart || []).some((c) => c.prod_id === product.id) ? (
          <Button variant="secondary" disabled>
            ADDED
          </Button>
        ) : (
          <Button
            variant="warning"
            onClick={() =>
              dispatch(
                alterCart({
                  prod_id: product.id,
                  quantity: 1,
                  meta_data: [],
                })
              )
            }
            disabled={product?.stock_status !== "instock"}
          >
            {loading ? "LOADING ..." : "ADD TO CART"}
          </Button>
        )
      ) : (
        <></>
      )}
    </div>
  );
};

export default ProductContainer;
